





















































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class NavMenu extends Vue {
    @Prop() public menu!: { display?: boolean };

    public menuItems: any = [
        {
            icon: 'home',
            text: 'menu.home',
            route: '/'
        },
        {
            icon: 'emoji_events',
            text: 'menu.leagues',
            toggled: false,
            subMenus: [
                // We're expecting we already know LeagueIds.
                { text: 'FRANCE: Ligue 1', route: '/10/board', img: 'https://d37kf7rs4g1hyv.cloudfront.net/img/flags/64/ligue1A.png' },
                { text: 'GERMANY: Bundesliga', route: '/11/board', img: 'https://d37kf7rs4g1hyv.cloudfront.net/img/flags/64/bundesliga.png'},
                { text: 'ITALY: Serie A', route: '/13/board', img: 'https://d37kf7rs4g1hyv.cloudfront.net/img/flags/64/seriea.png'},
                { text: 'SPAIN: La Liga', route: '/14/board', img: 'https://d37kf7rs4g1hyv.cloudfront.net/img/flags/64/laliga.png'},
                { text: 'ENGLAND: Premier League', route: '/15/board', img: 'https://d37kf7rs4g1hyv.cloudfront.net/img/flags/64/epl.png'},
            ]
        }
    ];

    public goToRoute(route: string): void {
        if (!!route) {
            this.$router.push(route);
        }
    }
}
